import { render, staticRenderFns } from "./add-answer.vue?vue&type=template&id=659584b0&scoped=true"
import script from "./add-answer.vue?vue&type=script&lang=js"
export * from "./add-answer.vue?vue&type=script&lang=js"
import style0 from "./add-answer.vue?vue&type=style&index=0&id=659584b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659584b0",
  null
  
)

export default component.exports